import { type FC, type ReactNode } from 'react';

import TimerOutlined from '@mui/icons-material/TimerOutlined';

import { Icon, type IconProp, type IconProps, type IconSize } from '@craft/ui/components/icons';
import { Stack, type StackProps } from '@craft/ui/components/structural';
import { Typography, type TypographyProps } from '@craft/ui/components/typography';

export interface IconTextDisplayProps extends Omit<StackProps, 'alignItems' | 'children'> {
  readonly children?: ReactNode;
  readonly direction?: Extract<StackProps['direction'], 'row' | 'row-reverse'>;
  readonly icon?: IconProp | null;
  readonly iconProps?: Omit<IconProps, 'icon' | 'size'>;
  readonly iconSize?: IconSize;
  readonly typographyProps?: Omit<TypographyProps<'span'>, 'children'>;
}

export const IconTextDisplay: FC<IconTextDisplayProps> = ({
  children,
  direction = 'row',
  icon = TimerOutlined,
  iconProps,
  iconSize = 16,
  typographyProps,
  ...props
}) => (
  <Stack gap={1} {...props} alignItems='center' direction={direction}>
    <Icon color='action' {...iconProps} icon={icon} size={iconSize} />
    <Typography
      component='div'
      flexShrink={0}
      fontSize='0.875rem'
      fontWeight={500}
      letterSpacing={0.05}
      lineClamp={1}
      {...typographyProps}
    >
      {children}
    </Typography>
  </Stack>
);
